import { HousingFormPageHeaderCard } from '@app/components/blocks/card/HousingFormPageHeaderCard'
import { Title } from '@app/components/core/typography/Title'
import { PageLayout } from '@app/pages/layout/PageLayout'
import { Head, useQuery } from '@based/sdk/react'
import { useMemo } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import useTransform from '@app/util/useTransform'
import { Card } from '@app/components/blocks/card/Card'
import { fullName } from '@app/util/helpers'
import { TabContent } from './TabContent'
import { HousingFormPagePopularHousingFormsCard } from './sections/HousingFormPagePopularHousingFormsCard'
import { ItemListCardItem } from '@app/components/blocks/card/ItemListCard'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { DiscoverPageLayout } from '@app/pages/layout/DiscoverPageLayout'

export type HousingFormPageProps = {
  id: string
}

export const HousingFormPage = ({ id }: HousingFormPageProps) => {
  const t = useTranslations().app
  const transformStyle = useTransform()
  const [, setLocation] = useLocation()
  const housingFormQuery = useQuery('view-housing-form', { id })
  const housingForm: ViewHousingFormModel | undefined = housingFormQuery.data

  const excludeIds = useMemo(() => [housingForm?.id], [housingForm?.id])

  if (housingFormQuery.loading || !housingForm) {
    return <div>{t.housingFormPage.loading}</div>
  }

  return (
    <PageLayout gap="2rem" standardPageTitle={false}>
      <Head>
        <title>{`${housingForm.title} | CrowdBuilding`}</title>
        <meta name="description" content={housingForm.description} />
      </Head>
      <DiscoverPageLayout
        style={transformStyle}
        sidebar={

          <>
            <HousingFormPagePopularHousingFormsCard excludeIds={excludeIds} />
            {housingForm?.ambassador && (
              <Card>
                <Title.H5>{t.housingFormPage.ambassadorCard.title}</Title.H5>
                <ItemListCardItem
                  item={{
                    image: housingForm?.ambassador?.avatar?.src || '',
                    title: fullName(housingForm?.ambassador),
                    onClick: () =>
                      setLocation(
                        pages.profile(housingForm?.ambassador?.handle),
                      ),
                  }}
                />
              </Card>
            )}
          </>
        }
      >
        <HousingFormPageHeaderCard style={{ flex: 1 }} housingForm={housingForm} />
        <TabContent housingForm={housingForm} />
      </DiscoverPageLayout>
    </PageLayout>
  )
}
